import { HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { NoDataToDisplayComponent } from '@connect-services/client/components/no-data-to-display/no-data-to-display.component';
import { GoogleStreetViewService } from '@connect-services/client/services/immersive-view/google-street-view.service';
import {
    ImmersiveViewErrorEnum,
    ImmersiveViewPosition,
    ImmersiveViewService,
} from '@connect-services/client/services/immersive-view/immersive-view.service';
import { ImmersiveViewUiService } from '@connect-services/client/services/immersive-view/immersive-view-ui.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, LoadingComponent, NoDataToDisplayComponent, RessourcesModule],
    selector: 'app-immersive-view-overlay',
    styleUrl: './../immersive-view.component.scss',
    templateUrl: './immersive-view-overlay.component.html',
})
export class ImmersiveViewOverlayComponent {
    protected readonly ButtonType = ButtonType;
    protected readonly errorMessage = computed<string>(() => {
        const error: ImmersiveViewErrorEnum | null = this.immersiveViewService.error();

        return error ? this.errorMessages()[error] : '';
    });
    protected readonly googleStreetViewService = inject(GoogleStreetViewService);
    protected readonly immersiveViewService = inject(ImmersiveViewService);
    protected readonly immersiveViewUiService = inject(ImmersiveViewUiService);

    private readonly errorMessages = computed<Record<ImmersiveViewErrorEnum, string>>(() => ({
        [ImmersiveViewErrorEnum.GOOGLE_QUOTA_EXHAUSTED]: this.googleStreetViewService.noAvailableQuotaMessage(),
        [ImmersiveViewErrorEnum.PANORAMA_NOT_FOUND]: 'immersiveView.noImmersiveViewAvailable',
        [ImmersiveViewErrorEnum.ACCESS_DENIED]: 'immersiveView.accessDenied',
        [ImmersiveViewErrorEnum.VIEWER_UNAVAILABLE]: 'immersiveView.viewerUnavailable',
    }));

    protected navigateToGoogleMaps(): void {
        const position: ImmersiveViewPosition | null = this.immersiveViewService.markerPosition();

        if (!position) {
            return;
        }

        const params: HttpParams = new HttpParams().set('layer', 'c').set('cbll', `${position.lat},${position.lng}`);

        window.open(`https://maps.google.com/maps?${params.toString()}`, '_blank')?.focus();
    }
}
